import Home from "./Home"
import Columns from "./Columns"

export { Home, Columns }
export default Home
